<template>
  <div class="row" v-if="question">

    <div :class="question.picture ? 'col-md-8' : 'col-sm-12'">
      <div>
        <h4 style="color: black;" class="font-bold" v-if="question.title">{{question.title}}</h4>
        <div class="text-muted font-bold m-b-xs">Overview :</div>
        <p>
          <template v-if="question.company_profile">{{question.company_profile}}</template>
          <template v-if="question.objective">{{question.objective}}</template> <br>
          <template v-if="question.issue"><br>{{question.issue}}</template>
          <template v-if="question.restraint">{{question.restraint}}</template>
          <template v-if="question.expert_interest"><br>{{question.expert_interest}}</template>
        </p>
      </div>

    </div>
    <div v-if="question.picture" class="col-sm-12 col-md-4 text-center">
      <a :href="$apiUrl + question.picture" target="_blank">
        <img :src="$apiUrl + question.picture"  style="max-width: 100%;max-height: 300px"/>
      </a>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  name: 'QuestionResumeLarge',
  props: ['question'],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  beforeMount () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/resume/QuestionResumeLarge.vue